/**
 * CE QUE L'ÉDITEUR D'UN MODÈLE DE COURRIEL MONTRE, par type (variables, destinataire, icône, copies, options).
 * Lot MC (2026-10-28) : un seul endroit, lu par les écrans de Paramétrage ET par « Modèles de courriel… » des fenêtres
 * d'envoi — sans quoi l'éditeur ouvert depuis une fenêtre montrerait d'autres variables que celui du Paramétrage.
 * (Le Planning oraux et le Planning annuel gardent leur description dans leur module.)
 */

/** Tuteurs (E144) : « Information tuteur » et « Information du suivi ». */
export const COURRIELS_TUTEURS = {
    tuteur_affectation: {
        destinataire: 'Tuteur pédagogique', icone: 'fa-chalkboard-user',
        sousTitre: 'Un message par tuteur, la liste de ses étudiants',
        variables: ['{prenom_tuteur}', '{nom_tuteur}', '{nombre_etudiants}', '{liste_etudiants}', '{portail_cfa}', '{nom_utilisateur}'],
        noteLien: "{liste_etudiants} : une ligne par étudiant (formation, entreprise, dates, échéance de visite) avec le lien personnel de sa fiche de visite — pour un apprenti suivi par le CFA, le lien du portail du CFA (Paramétrage → CFA). Les liens sont fabriqués à l'envoi : ne les saisissez pas."
    },
    maitre_suivi: {
        destinataire: "Maître de stage / d'apprentissage", icone: 'fa-briefcase',
        sousTitre: "Au maître : qui est le tuteur, et qu'il prendra contact",
        variables: ['{prenom_maitre}', '{nom_maitre}', '{prenom_nom_maitre}', '{prenom_nom_etudiant}', '{prenom_nom_tuteur}', '{email_tuteur}', '{type_contrat}', '{periode}', '{formation}', '{nom_utilisateur}'],
        ccSupplementaires: [{ cle: 'cc_etudiant', libelle: 'Cc : étudiant' }, { cle: 'cc_tuteur', libelle: 'Cc : tuteur' }],
        noteLien: 'Ce courriel ne porte pas de lien : il présente le tuteur au maître de stage.'
    }
};

/** Tuteurs → Paramétrage → CFA (lot 3.5d-2) : « Transmission au CFA ». */
export const COURRIEL_CFA = {
    destinataire: 'CFA (adresse réglée ci-dessus)', icone: 'fa-paper-plane',
    sousTitre: 'Tuteurs des alternants · À : CFA',
    variables: ['{tableau_affectations}', '{nombre_alternants}', '{departement}', '{annee}', '{nom_cfa}', '{nom_utilisateur}'],
    noteLien: "{tableau_affectations} : le tableau des alternants cochés dans la fenêtre d'envoi, avec les colonnes réglées ci-dessus. Il est fabriqué à l'envoi : ne le saisissez pas.",
    options: [{ cle: 'joindre_excel', libelle: 'Joindre le fichier Excel',
                aide: '(envoi par le serveur ; en secours messagerie, le fichier se télécharge pour être joint à la main)' }]
};

/** Certification (lot C.0 bis) : dépôt, maître, correction. */
export const COURRIELS_CERTIF = {
    certif_depot: {
        icone: 'fa-file-arrow-up', destinataire: 'Étudiant',
        sousTitre: "Envoi collectif, envoi individuel, relance de l'étudiant",
        variables: ['{prenom_etudiant}', '{formation}', '{processus}', '{periode}', '{date_limite_depot}', '{liste_documents}', '{lien}', '{nom_utilisateur}'],
        noteLien: "{lien} devient le « Lien personnel de dépôt » de chaque étudiant, posé par le serveur : ne le saisissez pas à la main."
    },
    certif_maitre: {
        icone: 'fa-stamp', destinataire: "Maître de stage ou d'apprentissage",
        sousTitre: "À la validation de l'étudiant (automatique), relance et renvoi",
        variables: ['{nom_certificateur}', '{prenom_nom_etudiant}', '{formation}', '{processus}', '{periode}', '{date_limite_certification}', '{liste_documents}', '{lien}', '{nom_utilisateur}'],
        noteLien: "{lien} devient le « Lien personnel de certification » du maître, posé par le serveur. Pour l'envoi automatique, {nom_utilisateur} est l'assistante qui a lancé le processus."
    },
    certif_correction: {
        icone: 'fa-pen-to-square', destinataire: 'Étudiant',
        sousTitre: 'Après un « ne peut pas certifier » du maître',
        variables: ['{prenom_etudiant}', '{processus}', '{liste_documents}', '{motif}', '{date_limite_depot}', '{lien}', '{nom_utilisateur}'],
        noteLien: "{lien} devient le « Lien personnel de dépôt » de l'étudiant ; {motif} est celui écrit par le maître."
    }
};

/**
 * Les courriels du SUIVI DE STAGE (MC.3) : l'éditeur tire déjà leurs variables, leur destinataire et leur icône de ses
 * propres tables (StageParametrageContacts : VARIABLES, DESTINATAIRE_PRINCIPAL, ICONES_MAIL) — rien à répéter ici.
 */
const TYPES_STAGE = ['etudiant_lien', 'maitre_fiche', 'fiche_validee', 'convention_depot', 'grille_eval',
    'depot_a_corriger', 'stage_refuse', 'fiche_etudiant_a_corriger'];

/** La présentation d'un type, pour la fenêtre « Modèles de courriel… » (null : type sans éditeur depuis une fenêtre). */
export function presentationDe(typeMail) {
    if (COURRIELS_TUTEURS[typeMail]) return COURRIELS_TUTEURS[typeMail];
    if (typeMail === 'cfa_transmission') return COURRIEL_CFA;
    if (COURRIELS_CERTIF[typeMail]) return COURRIELS_CERTIF[typeMail];
    if (TYPES_STAGE.includes(typeMail)) return {};
    return null;
}
